<form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">

    <nav class="toolbar navbar navbar-light">
        <div class="form-inline">
            <button class="btnback btn btn-outline-success" type="button" (click)="onBack()" title="Volver"><i class="fa fa-chevron-left"></i></button>
            <button type="submit" class="btn btn-outline-success" title="Guardar"><i class="fa fa-save"></i> Guardar</button>
        </div>

    </nav>

    <div class="animated fadeIn container-fluid">

        <h4>{{editTitle}} Número de Seguridad</h4>

        <div class="row">
            <div class="col-md-12">

                <div class="card card-accent-success animated fadeIn">

                    <div class="card-body">

                        <div class="row">

                            <div class="form-group col-md-2">
                                <label class="col-form-label required-field" for="inpPagina">Página</label>

                                <ng-select loadingText="Cargando..."
                                           [items]="listPaginas"
                                           placeholder="-- Seleccione un Nº Página --"
                                           [loading]="!listPaginas"
                                           bindLabel="Descripcion"
                                           bindValue="Id"
                                           formControlName="IdPagina"
                                           notFoundText="Página no encontrada"
                                           [ngClass]="displayFieldCssNgSelect('IdPagina')"
                                           clearAllText="Eliminar selección">
                                </ng-select>

                                <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdPagina','required')">
                                    Página es obligatorio
                                </div>

                                <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdPagina','pagina_duplicated')">
                                    La Página ya existe
                                </div>
                            </div>

                            <div class="form-group col-md-2">
                                <label class="col-form-label" for="intZona">Zona</label>

                                <ng-select loadingText="Cargando..."
                                           [items]="listZona"
                                           bindLabel="Descripcion"
                                           bindValue="Id"
                                           formControlName="IdZona"
                                           [loading]="!listZona"
                                           notFoundText="Zona no encontrada"
                                           placeholder="-- Seleccione una Zona --"
                                           clearAllText="Eliminar selección"
                                           [ngClass]="displayFieldCssNgSelect('IdZona')"
                                           (change)="onSelectZona($event)">
                                </ng-select>

                            </div>

                            <div class="form-group col-md-4">
                                <label class="col-form-label" for="intEstado">Punto de Inspección</label>
                                <ng-select [items]="listPuntosInspeccion"
                                           bindLabel="Descripcion"
                                           bindValue="Id"
                                           formControlName="IdPuntoInspeccion"
                                           loadingText="Cargando..."
                                           [loading]="!listPuntosInspeccion && form.value.IdZona > 0"
                                           notFoundText="Punto Inspección no encontrado"
                                           placeholder="-- Seleccione un Punto de Inspección --"
                                           [ngClass]="displayFieldCssNgSelect('IdPuntoInspeccion')"
                                           clearAllText="Eliminar selección">
                                    <ng-template ng-option-tmp let-item="item">
                                        <div container="body" ngbTooltip="{{item.Descripcion}}">{{item.Descripcion}}</div>
                                    </ng-template>
                                </ng-select>
                            </div>

                            <div class="form-group col-md-4">
                                <label class="col-form-label required-field" for="inpDescripcion">Nº Seguridad</label>
                                <input formControlName="NumSeguridad" name="Descripcion" title="" class="form-control" numbersOnly
                                       maxlength="7" [ngClass]="displayFieldCss('NumSeguridad')" id="inpDescripcion" type="text" value="">

                                <div class="invalid-feedback" *ngIf="isFieldInvalid('NumSeguridad','required')">
                                    Nº Seguridad es obligatorio
                                </div>

                                <div class="invalid-feedback" *ngIf="isFieldInvalid('NumSeguridad','numseguridad_duplicated')">
                                    El Nº Seguridad ya existe
                                </div>
                            </div>

                        </div>

                        <div class="row">
                            <div class="form-group col-md-4">
                                <label class="col-form-label" for="intEstado">Nº Solicitud Copia</label>
                                <ng-select [items]="listCopiasCertificadoEx"
                                           bindLabel="Descripcion"
                                           bindValue="Id"
                                           formControlName="IdCopiaEx"
                                           loadingText="Cargando..."
                                           [loading]="!listCopiasCertificadoEx"
                                           notFoundText="Copia Certificado no encontrada"
                                           placeholder="-- Seleccione una Copia --"
                                           [ngClass]="displayFieldCssNgSelect('IdCopiaEx')"
                                           clearAllText="Eliminar selección">
                                    <ng-template ng-option-tmp let-item="item">
                                        <div container="body" ngbTooltip="{{item.Descripcion}}">{{item.Descripcion}}</div>
                                    </ng-template>
                                </ng-select>
                            </div>
                        </div>



                    </div>
                </div>
            </div>
        </div>

    </div>

</form>
